export default __webpack_public_path__ + "static/floating-dark-58335bbb7c4b2b5172c07232a422a9f9767b5798df5aa9448d7e2713fac43d4e.png";